import {
    OFFER_POI_CATEGORY_ORDER,
    OFFER_POI_KOLEJ_SKM_LABEL,
    OFFER_POI_SKM_CITIES,
    OFFER_POI_TYPE_CATEGORY,
    OFFER_POI_TYPE_PRESENTATION,
    OfferPoiCategory
} from "../constants/offer_poi_tag_config";
import {IOfferPoiEntry, OFFER_POI_TAGS} from "../constants/offer_poi_tags";
import {OfferPoiType} from "../constants/offer_poi_tags_enum";
import {IOfferBoxOffer} from "../types/IOfferBoxOffer";
import {IOfferListUsp} from "../types/IOfferListUsp";

const roundDistanceTo10 = (meters: number): number => Math.max(10, Math.round(meters / 10) * 10);

const isSkmRegion = (offer: IOfferBoxOffer): boolean => {
    const region = offer.region as Record<string, unknown>;
    return [region.city, region.town, region.district, region.name, region.short_name].some(
        (value) => typeof value === "string" && OFFER_POI_SKM_CITIES.includes(value)
    );
};

const getPoiLabel = (type: OfferPoiType, isSkm: boolean): string => {
    if (type === OfferPoiType.KOLEJ && isSkm) {
        return OFFER_POI_KOLEJ_SKM_LABEL;
    }
    return OFFER_POI_TYPE_PRESENTATION[type].label;
};

const getPrimaryEntry = (entries: IOfferPoiEntry[], category: OfferPoiCategory): IOfferPoiEntry => {
    if (category === OfferPoiCategory.RAIL) {
        const nearestMetro = entries.find((entry) => entry.type === OfferPoiType.METRO);
        if (nearestMetro) {
            return nearestMetro;
        }
    }
    return entries[0];
};

/**
 * Builds the USP pills for an offer tile from hardcoded POI data (TEMP, until BE US-616.1):
 * one pill per category (rail → park → forest → nature reserve → transit), showing the nearest
 * POI's distance and a tooltip with the full category list. `offer.usps` (real API) takes precedence.
 */
export const getOfferUsps = (offer: IOfferBoxOffer): IOfferListUsp[] => {
    if (offer.usps && offer.usps.length > 0) {
        return offer.usps;
    }

    const entries = OFFER_POI_TAGS[offer.id] ?? [];
    if (entries.length === 0) {
        return [];
    }

    const isSkm = isSkmRegion(offer);

    // Group by category, preserving the by-distance order of `entries`.
    const entriesByCategory = new Map<OfferPoiCategory, IOfferPoiEntry[]>();
    for (const entry of entries) {
        const category = OFFER_POI_TYPE_CATEGORY[entry.type];
        const categoryEntries = entriesByCategory.get(category) ?? [];
        categoryEntries.push(entry);
        entriesByCategory.set(category, categoryEntries);
    }

    const usps: IOfferListUsp[] = [];
    OFFER_POI_CATEGORY_ORDER.forEach((category, index) => {
        const categoryEntries = entriesByCategory.get(category);
        if (!categoryEntries || categoryEntries.length === 0) {
            return;
        }

        const primary = getPrimaryEntry(categoryEntries, category);

        usps.push({
            id: index,
            label: `${getPoiLabel(primary.type, isSkm)}: ${roundDistanceTo10(primary.distance)} m`,
            icon: OFFER_POI_TYPE_PRESENTATION[primary.type].icon,
            variant: "default",
            tooltipItems: categoryEntries.map((entry) => ({name: entry.name, distance: roundDistanceTo10(entry.distance)}))
        });
    });

    return usps;
};
import {
    OFFER_POI_CATEGORY_ORDER,
    OFFER_POI_KOLEJ_SKM_LABEL,
    OFFER_POI_SKM_CITIES,
    OFFER_POI_TYPE_CATEGORY,
    OFFER_POI_TYPE_PRESENTATION,
    OfferPoiCategory
} from "../constants/offer_poi_tag_config";
import {IOfferPoiEntry, OFFER_POI_TAGS} from "../constants/offer_poi_tags";
import {OfferPoiType} from "../constants/offer_poi_tags_enum";
import {IOfferBoxOffer} from "../types/IOfferBoxOffer";
import {IOfferListUsp} from "../types/IOfferListUsp";

const roundDistanceTo10 = (meters: number): number => Math.max(10, Math.round(meters / 10) * 10);

const isSkmRegion = (offer: IOfferBoxOffer): boolean => {
    const region = offer.region as Record<string, unknown>;
    return [region.city, region.town, region.district, region.name, region.short_name].some(
        (value) => typeof value === "string" && OFFER_POI_SKM_CITIES.includes(value)
    );
};

const getPoiLabel = (type: OfferPoiType, isSkm: boolean): string => {
    if (type === OfferPoiType.KOLEJ && isSkm) {
        return OFFER_POI_KOLEJ_SKM_LABEL;
    }
    return OFFER_POI_TYPE_PRESENTATION[type].label;
};

const getPrimaryEntry = (entries: IOfferPoiEntry[], category: OfferPoiCategory): IOfferPoiEntry => {
    if (category === OfferPoiCategory.RAIL) {
        const nearestMetro = entries.find((entry) => entry.type === OfferPoiType.METRO);
        if (nearestMetro) {
            return nearestMetro;
        }
    }
    return entries[0];
};

/**
 * Builds the USP pills for an offer tile from hardcoded POI data (TEMP, until BE US-616.1):
 * one pill per category (rail → park → forest → nature reserve → transit), showing the nearest
 * POI's distance and a tooltip with the full category list. `offer.usps` (real API) takes precedence.
 */
export const getOfferUsps = (offer: IOfferBoxOffer): IOfferListUsp[] => {
    if (offer.usps && offer.usps.length > 0) {
        return offer.usps;
    }

    const entries = OFFER_POI_TAGS[offer.id] ?? [];
    if (entries.length === 0) {
        return [];
    }

    const isSkm = isSkmRegion(offer);

    // Group by category, preserving the by-distance order of `entries`.
    const entriesByCategory = new Map<OfferPoiCategory, IOfferPoiEntry[]>();
    for (const entry of entries) {
        const category = OFFER_POI_TYPE_CATEGORY[entry.type];
        const categoryEntries = entriesByCategory.get(category) ?? [];
        categoryEntries.push(entry);
        entriesByCategory.set(category, categoryEntries);
    }

    const usps: IOfferListUsp[] = [];
    OFFER_POI_CATEGORY_ORDER.forEach((category, index) => {
        const categoryEntries = entriesByCategory.get(category);
        if (!categoryEntries || categoryEntries.length === 0) {
            return;
        }

        const primary = getPrimaryEntry(categoryEntries, category);

        usps.push({
            id: index,
            label: `${getPoiLabel(primary.type, isSkm)}: ${roundDistanceTo10(primary.distance)} m`,
            icon: OFFER_POI_TYPE_PRESENTATION[primary.type].icon,
            variant: "default",
            tooltipItems: categoryEntries.map((entry) => ({name: entry.name, distance: roundDistanceTo10(entry.distance)}))
        });
    });

    return usps;
};
